import axiosInstance from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// @ List all permission entries
export const permissionsList = async () => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/admin_permission_list`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List all game client download entries
export const downloadList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.get(`/download_versions`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Show game client download entry
export const downloadGet = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.get(`/admin/download_versions/${payload.id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Update game client download entry
export const downloadUpdate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.put(`/admin/download_versions`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Create game client download entry
export const downloadCreate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/admin/download_versions`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List game client feedback submissions - paginated
// @ order_by supported values: created_at, created_at_asc, updated_at, updated_at_asc,
// @   submitted_at, submitted_at_asc, reviewed_at, reviewed_at_asc
// @   the bare value is descending - append _asc for ascending
// @ payload: {
// @   "page_info": { "limit": 25, "offset": 0, "order_by": "submitted_at" },
// @   "user_id": "", "licenseid": "", "categories": ["bug"],
// @   "reviewed": true, "reviewed_by": "",
// @   "submitted_at_from": "2019-08-24T14:15:22Z", "submitted_at_to": "2019-08-24T14:15:22Z",
// @   "reviewed_at_from": "2019-08-24T14:15:22Z", "reviewed_at_to": "2019-08-24T14:15:22Z",
// @   "text_contains": "", "admin_notes_contains": ""
// @ }
export const gameClientFeedbackList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/game_client_feedback_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Create or replace the admin notes on a game client feedback entry
// @ admin_notes is a free-form JSON blob - the portal stores the notes textarea under `notes`
// @ payload: {
// @   "id": "2fa515eg-5483-6984-b69c-26f4a9346b4c",
// @   "admin_notes": { "notes": "" }
// @ }
export const gameClientFeedbackUpsertNotes = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/game_client_feedback_upsert_notes`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
